var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "默认banner详情",
        visible: _vm.drawer,
        "destroy-on-close": true,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        size: "40%",
        withHeader: "false",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _c("div", { staticClass: "title-box" }, [_vm._v("基本信息")]),
      _c(
        "el-descriptions",
        { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
        [
          _c("el-descriptions-item", { attrs: { label: "banner名称" } }, [
            _vm._v(_vm._s(_vm.info.name)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "选用模板" } }, [
            _vm._v("\n      " + _vm._s(_vm.info.adTemplateName) + "\n    "),
          ]),
          _c("el-descriptions-item", { attrs: { label: "组内位置" } }, [
            _vm._v(_vm._s(_vm.info.slotKey || "-")),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "title-box" }, [_vm._v("banner预览")]),
      _c("div", { staticClass: "preview-box" }, [
        _vm.info.adTemplateName === "1*4 banner位"
          ? _c("div", { staticClass: "preview" }, [
              _c("div", [
                _c("img", { attrs: { src: _vm.info.marketImgUrl, alt: "" } }),
              ]),
              _c("div", [
                _c("img", { attrs: { src: _vm.info.imgUrl, alt: "" } }),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.info.marketText))]),
            ])
          : _c("div", { staticClass: "preview" }, [
              _c("img", { attrs: { src: _vm.info.imgUrl, alt: "" } }),
            ]),
      ]),
      _c("div", { staticClass: "title-box" }, [_vm._v("页面跳转")]),
      _c(
        "el-descriptions",
        { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
        [
          _c("el-descriptions-item", { attrs: { label: "跳转页面" } }, [
            _vm._v(_vm._s(_vm.info.pageUrl || "-")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "跳转类型" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.getPageUrlType(_vm.info.pageUrlType)) +
                "\n    "
            ),
          ]),
          _vm.info.pageUrlType === 3
            ? _c("el-descriptions-item", { attrs: { label: "APPID" } }, [
                _vm._v("\n      " + _vm._s(_vm.info.appId || "-") + "\n    "),
              ])
            : _vm._e(),
          _vm.info.pageUrlType === 3
            ? _c("el-descriptions-item", { attrs: { label: "账号原始ID" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.info.appletOriginalId || "-") +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _c("el-descriptions-item", { attrs: { label: "展示渠道" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.getDisplayChannels(_vm.info.displayChannel)) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "title-box" }, [_vm._v("其他信息")]),
      _c(
        "el-descriptions",
        { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
        [
          _c("el-descriptions-item", { attrs: { label: "创建人" } }, [
            _vm._v(_vm._s(_vm.info.createUserName || "-")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
            _vm._v(_vm._s(_vm.info.createTime || "-")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "审核人" } }, [
            _vm._v(_vm._s(_vm.info.auditUserName || "-")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "审核时间" } }, [
            _vm._v(_vm._s(_vm.info.auditTime || "-")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "最新编辑人" } }, [
            _vm._v(_vm._s(_vm.info.updateUserName || "-")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "编辑时间" } }, [
            _vm._v(_vm._s(_vm.info.updateTime || "-")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "广告状态" } }, [
            _vm._v(_vm._s(_vm.getBannerStatus(_vm.info.status))),
          ]),
          _vm.info.refuseReason
            ? _c("el-descriptions-item", { attrs: { label: "审核拒绝原因" } }, [
                _vm._v("\n      " + _vm._s(_vm.info.refuseReason) + "\n    "),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }